module.exports = __webpack_public_path__ + "d86d8fe3290db351ab7a282090de7104.svg";